"use strict";

var encodeNumberAsBase10String = require("./encode-number-as-base10-string");
var prefixHex = require("./prefix-hex");
var unfixSigned = require("./unfix-signed");

// Unroll an abi-encoded string into an array
function unrollArray(string, returns, stride, init) {
  if (string && string.length >= 66) {
    stride = stride || 64;
    var elements = Math.ceil((string.length - 2) / stride);
    var array = new Array(elements);
    var position = init || 2;
    for (var i = 0; i < elements; ++i) {
      array[i] = prefixHex(string.slice(position, position + stride));
      position += stride;
    }
    if (array.length) {
      if (parseInt(array[1], 16) === array.length - 2 || parseInt(array[1], 16) / 32 === array.length - 2) {
        array.splice(0, 2);
      }
    }
    for (i = 0; i < array.length; ++i) {
      if (returns === "number[]") {
        array[i] = encodeNumberAsBase10String(array[i]);
      } else if (returns === "unfix[]") {
        array[i] = unfixSigned(array[i], "string");
      }
    }
    return array;
  }
  return string;
}

module.exports = unrollArray;



//////////////////
// WEBPACK FOOTER
// ./node_modules/speedomatic/src/unroll-array.js
// module id = 1312
// module chunks = 157